export default {"src":"/_next/static/media/remoteHiring.2ac70d28.svg","height":389,"width":399,"blurWidth":0,"blurHeight":0};